import { MenuOutlined, DollarOutlined } from "@ant-design/icons";
import { Avatar, Dropdown } from "antd";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import { formatCurrencyVND } from "../../../share/base/common/common";
import CommonBase from "../../../share/base/network/axiosNetwork";
import {
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
} from "@ant-design/icons";
import "./MobileHeader.scss";

function MobileHeader({ onToggle, userInfo, walletInfo, history }) {
  const sigOut = () => {
    CommonBase.setLogOut();
  };

  const userMenuItem = [
    {
      key: "profile",
      icon: <UserOutlined />,
      label: "Thông tin cá nhân",
    },
    {
      key: "settings",
      icon: <SettingOutlined />,
      label: "Cài đặt tài khoản",
    },
    { type: "divider" },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "Đăng xuất",
      danger: true,
    },
  ];

  const handleUserMenuClick = ({ key }) => {
    if (key === "logout") {
      sigOut();
    } else if (key === "profile") {
      history.push("/profile");
    } else if (key === "settings") {
      history.push("/profile");
    }
  };

  return (
    <header className="mobile-header">
      <div className="mobile-header-left">
        <button className="mobile-menu-btn" onClick={onToggle}>
          <MenuOutlined />
        </button>
      </div>

      <div className="mobile-header-right">
        <div className="mobile-wallet">
          <DollarOutlined />
          <span>{walletInfo?.balance ? formatCurrencyVND(walletInfo.balance) : "0"}</span>
        </div>

        <Dropdown
          menu={{ items: userMenuItem, onClick: handleUserMenuClick }}
          trigger={["click"]}
          placement="bottomRight"
        >
          <div className="mobile-user">
            <Avatar
              size={32}
              src={userInfo?.avatar || "/assets/img/userlogin.jpg"}
            />
          </div>
        </Dropdown>
      </div>
    </header>
  );
}

const mapStateToProps = (state) => {
  let { userInfo } = state.loginReducer.toJS();
  let { walletInfo } = state.walletReducer.toJS();
  return {
    userInfo: userInfo?.userInfo,
    walletInfo: walletInfo,
  };
};

export default connect(mapStateToProps)(withRouter(MobileHeader));
